<template>
  <div class="nodata" :class="anim === 'social' ? 'post list-complete-item' : ''">
    <div class="nodata-inner">

      

      <div class="nodata-icon-container" v-if="anim == null && icon !=null">
        <i :style="'background-image: url(/static/menuicons/' + icon + '.svg);'" style="position:absolute"></i>
      </div>
      
      <div class="nodata-anim-container" v-if="anim != null && icon == null">
        <template v-if="anim == 'social'">
          <lottie-animation :path="'./static/lottie/holacon-social-hub-lottie-v2.json'" v-if="type == null"/>
          <lottie-animation :path="'./static/lottie/holacon-ask-speaker-lottie.json'"  v-if="type == 0"/>
          <lottie-animation :path="'./static/lottie/holacon-polls-lottie.json'"  v-if="type == 1"/>
          <lottie-animation :path="'./static/lottie/holacon-surveys-lottie.json'" v-if="type == 2"/>
        </template>
        <lottie-animation v-else :path="'./static/lottie/' + anim + '.json'"/>
      </div>
    </div>

    <h3 v-if="title != null && title != '' && title != undefined">{{ title }}</h3>
    <p v-if="description != null && description != '' && description != undefined">{{ description }}</p>

    <el-button style="margin-top:20px" :style="this.$route.path.search('/event/') ? 'background-color: ' + this.currentEvent.color + '; border-color: ' + this.currentEvent.color : ''" size="small" icon="fas fa-redo-alt" type="primary" v-if="button != undefined" :disabled="loading" :loading="loading" @click.stop="buttonPress" round>{{ button }}</el-button>

  </div>
</template>

<script>
import LottieAnimation from "lottie-vuejs/src/LottieAnimation.vue";

export default {
  name: "Nodata",
  props: ["description", "loading", "title", "icon", "button", "onPress", "anim","type"],
  components: {
    LottieAnimation,
  },
  methods: {
    buttonPress() {
      this.$emit("btnClick");
    },
  },
  computed: {
    currentEvent() {
      return this.$store.getters.getEvent;
    },
    routeName(){
       return this.$route.name
    },
    routePath(){
       return this.$route.path 
    },
  },
};
</script>

<style lang="less">
.nodata {
  padding: 10px 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  margin: 0 auto;
  text-align: center !important;

  .nodata-inner {
    display: flex; 
    align-items: center; 
    justify-content: center;
    position: relative; 
    
    .nodata-icon-container {
      border-radius: 8px;
      width: 70px;
      height: 70px;
      background: #ededed;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      text-decoration: none;

        i {
          opacity: 0.5;
          margin-bottom: 0px;
          display: block;
          background-position: 50%;
          background-repeat: no-repeat;
          background-size: contain;
          height: 60px;
          width: 60px;
          cursor: pointer;
        }
    }

    .nodata-anim-container {
      max-width: 220px;
      max-height: 220px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      text-decoration: none;

        div {
          height: 160px;
          width: 160px;
          mix-blend-mode: luminosity;
        }
    }

  }

  h3,
  p {
    margin: 0;
  }

  h3 {
    font-size: 20px;
        color: #292f3b!important;
  }

  p {
    font-size: 14px;
    margin-top: 5px;
    word-break: break-word;
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/NoData.vue